import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  tableWrap: {
    height: 'calc(100vh - 16rem)',
    overflow: 'auto',
    '@media all and (min-width: 620px) and (max-width: 1090px)': {
      height: 'calc(100vh - 23rem)',
      marginBottom: '1rem'
    },
    '@media all and (max-width: 620px)': {
      height: 'calc(100vh - 25rem)',
      marginBottom: '1rem'
    }
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  tableBody: { background: '#f9f9f9' }
}))

export default useStyles
